import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RepairsList from "@/pages/RepairsList";
import NewRepair from "@/pages/NewRepair";
import RepairDetail from "@/pages/RepairDetail";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Quotes from "@/pages/Quotes";
import Inventory from "@/pages/Inventory";
import WhatsAppPage from "@/pages/WhatsApp";
import Reports from "@/pages/Reports";
import SettingsPage from "@/pages/Settings";
import PublicTracking from "@/pages/public/PublicTracking";
import PublicQuote from "@/pages/public/PublicQuote";
import MobileUpload from "@/pages/public/MobileUpload";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex min-h-screen items-center justify-center text-muted-foreground">Caricamento…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/tracking" element={<PublicTracking />} />
      <Route path="/t/:token" element={<PublicTracking />} />
      <Route path="/preventivo/:token" element={<PublicQuote />} />
      <Route path="/u/:token" element={<MobileUpload />} />

      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/repairs" element={<RepairsList />} />
        <Route path="/repairs/new" element={<NewRepair />} />
        <Route path="/repairs/:id" element={<RepairDetail />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/whatsapp" element={<WhatsAppPage />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
